<template>
    <div class="content-strategy-modal blog-modal">
        <div class="blog-modal__modal import-modal">
            <button class="btn-link social-modal__exit btn-hover" @click.prevent="onClose()">
                <i class="fas fa-times"></i>Close
            </button>
            <div class="import-modal__wrap">
                <h1>Update This</h1>

                <div class="modal-content">
                    <div class="modal-content-wrap">

                        <!-- Title Field -->
                        <div class="modal-row" :class="{'has-error': formSubmitted && !fieldValue('title', 'title')}">
                            <div class="modal-col-header">Title*</div>
                            <div class="modal-col-text">
                                <!--<input type="text" 
                                    v-model="node.fieldGroups.title.fields.title.value" 
                                    placeholder="Enter title here" 
                                    :class="{'input-error': formSubmitted && !node.fieldGroups.title.fields.title.value}">-->

                                    <TextField
                                    :key="'nodeTitle'" 
                                    :fieldId="'nodeTitle'"
                                    :fieldPlaceholder="'Enter title here*'" 
                                    :isRequired="true" 
                                    :valueProp="node.fieldGroups.title.fields.title.value"
                                    @fieldUpdated="(value) => updateFieldValue($event, 'title', 'title', value)"
                                    ></TextField>
                                    <button class="add-node-form-ai-btn ai-generate-icon" @click.prevent="this.$store.commit('client/setAIPopUpFields', {prop: 'modals/titleField', val: true})" ><i class="fa-solid fa-wand-magic-sparkles"></i></button>
                            </div>
                        </div>

                        <div class="modal-row large-margin-bottom">
                            <div class="modal-col-header">Details</div>
                            <div class="modal-col-text">
                                <!--<textarea v-model="node.fieldGroups.details.fields.details.value" placeholder="Enter details here"></textarea>-->
                                <Textarea
                                :fieldId="'details'" 
                                :fieldPlaceholder="'Enter details here'" 
                                :isRequired="false" 
                                :valueProp="node.fieldGroups.details.fields.details.value"
                                @fieldUpdated="(value) => updateFieldValue($event, 'details', 'details', value)"
                                ></Textarea>
                                <button class="add-node-form-ai-btn ai-generate-icon" @click.prevent="this.$store.commit('client/setAIPopUpFields', {prop: 'modals/detailsField', val: true})" ><i class="fa-solid fa-wand-magic-sparkles"></i></button>
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Assign</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                    :key="selectKey" 
                                    v-model="node.fieldGroups.assign.fields.assign.value" 
                                    :options="getClientUsers" 
                                    label-by="username" 
                                    close-on-select
                                    :placeholder="this.node.fieldGroups.assign.fields.assign.value"
                                    />
                                </div>   
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Deadline</div>
                            <div class="modal-col-text">
                            	<div class="deadline form-item datepicker">
                                    <Datepicker v-model="node.fieldGroups.deadline.fields.deadline.value" class="form-control" dark autoApply format="dd/MM/yyyy HH:mm"></Datepicker>
                                </div>
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Keyword</div>
                            <div class="modal-col-text">
                                <!--<input type="text" 
                                    v-model="node.fieldGroups.keyword.fields.keyword.value" 
                                    placeholder="Enter keyword here">-->
                                <TextField 
                                :fieldId="'keyword'"
                                :fieldPlaceholder="'Enter keyword here'" 
                                :isRequired="false" 
                                :valueProp="node.fieldGroups.keyword.fields.keyword.value"
                                @fieldUpdated="updateKeyword"
                                ></TextField>    
                                <button class="access-keyword-planner-btn" @click.prevent="onOpenKeywordPlannerModal">Keyword Planner</button>    
                            </div>
                        </div>

                        <!-- Format Field -->
                        <div class="modal-row" :class="{'has-error': formSubmitted && !node.fieldGroups.format.fields.format.value}">
                            <div class="modal-col-header">Format*</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                        :key="selectKey1" 
                                        v-model="node.fieldGroups.format.fields.format.value" 
                                        :options="formats" 
                                        label-by="format" 
                                        close-on-select
                                        :class="{'input-error': formSubmitted && !node.fieldGroups.format.fields.format.value}"
                                        :placeholder="this.node.fieldGroups.format.fields.format.value"
                                    />
                                </div>
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Intent</div>
                            <div class="modal-col-text">
                                <input type="text" v-model="node.fieldGroups.intent.fields.intent.value" placeholder="Enter intent here">
                            </div>
                        </div>

                        <div class="modal-row">
                            <div class="modal-col-header">Research</div>
                            <div class="modal-col-text">
                                <input type="text" v-model="node.fieldGroups.research.fields.research.value" placeholder="Enter research here">
                            </div>
                        </div>

                        <!-- Status Field -->
                        <!-- <div class="modal-row" :class="{'has-error': formSubmitted && !node.fieldGroups.status.fields.status.value}">
                            <div class="modal-col-header">Status*</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                        :key="selectKey" 
                                        v-model="node.fieldGroups.status.fields.status.value" 
                                        :options="statusOptions" 
                                        label-by="status" 
                                        close-on-select
                                        :class="{'input-error': formSubmitted && !node.fieldGroups.status.fields.status.value}"
                                        :placeholder="this.node.fieldGroups.status.fields.status.value"
                                    />
                                </div>
                            </div>
                        </div> -->

                        <div class="modal-row">
                            <div class="modal-col-header">Author</div>
                            <div class="modal-col-text">
                                <div class="styled-select">
                                    <VueNextSelect 
                                        :key="selectKey" 
                                        v-model="node.fieldGroups.author.fields.author.value" 
                                        :options="getClientUsers" 
                                        label-by="username" 
                                        close-on-select
                                        :placeholder="this.node.fieldGroups.author.fields.author.value"
                                    />
                                </div> 
                            </div>
                        </div>

                        <!-- <div class="modal-row">
                            <div class="modal-col-header">Created</div>
                            <div class="modal-col-text">
                                <div class="deadline form-item datepicker">
                                    <Datepicker v-model="node.fieldGroups.created.fields.created.value" class="form-control" dark autoApply format="dd/MM/yyyy HH:mm"></Datepicker>
                                </div>
                            </div>
                        </div> -->

                    </div>
                </div>

                <div class="btn-row">
                    <div class="content-strategy-error-modal"  v-if="errorMessage">
                        <h3>{{ errorMessage }}</h3>
                    </div>
                    <div class="btn-row-wrap">
                        <button class="btn-close" @click.prevent="onDelete()">
                            <i class="fas fa-times" aria-hidden="true"></i>Delete
                        </button>
                        <button class="btn-save" @click.prevent="handleSubmit()">
                            <i class="fa-solid fa-circle-check"></i>Update
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueNextSelect from 'vue-next-select';
import Datepicker from "vue3-date-time-picker";
import Node from '../../services/contentNodes';
import TextField from "../forms/inputs/TextField.vue";
import Textarea from "../forms/inputs/Textarea.vue";
import { mapState } from "vuex";

export default {
    components: {
        VueNextSelect,
        Datepicker,
        TextField,
        Textarea,
    },
    mounted(){
        console.log('getClientUsers', this.getClientUsers);
        console.log('getClientData', this.getClientData);
        const foundNode = this.getContentStrategy.nodes.find(node => node.id === this.getContentStrategy.currentNode)
        this.mapImportedNode(JSON.parse(JSON.stringify(foundNode)))
        console.log('EDIT NODE DATA', this.node);
    },
    watch:{
        'node.fieldGroups': {
            async handler(val) {
                console.log('edit node  field changedddd', val);
            },
            deep: true
        },
        'getCurrentNode.fieldGroups.keyword.fields.keyword.value': {
            async handler(val) {
                console.log('keyword value changed HELLO', val);
                this.node.fieldGroups.keyword.fields.keyword.value = val;
            },
            deep: true
        },
        'getContentStrategy.currentNode': {
            handler(newVal) {
                console.log('Watcher triggered with:', newVal); // Debugging
                if (newVal) {
                    const foundNode = this.getContentStrategy.nodes.find(node => node.id === newVal);
                    if (foundNode) {
                        this.mapImportedNode(JSON.parse(JSON.stringify(foundNode)));

                        console.log('mappedddd', foundNode);
                    }
                }
            },
            deep: true,
            immediate: true
        },
        'getAIPopUpFields.generatedContent'(newVal) {
            if (this.getAIPopUpFields.modals.titleField) {
                this.node.fieldGroups.title.fields.title.value = newVal;
            }
            if (this.getAIPopUpFields.modals.detailsField) {
                this.node.fieldGroups.details.fields.details.value = newVal;
            }
        },
        modalKeywordTitle(newVal) {
            if (newVal) {
                console.log('Watcher triggered: modal keyword changed →', newVal);

                this.node.fieldGroups.keyword.fields.keyword.value = newVal;
                this.updateFieldValue(newVal, 'keyword', 'keyword');
            }
        }
    },
    data() {
        return {
            formats: [{format: 'Blog'}, {format: 'Social'}],
            statusOptions: [
                {status: 'Title Created'},
                {status: 'Assigned'},
                {status: 'Pending review'},
                {status: 'Approved'},
                {status: 'Rejected'},
                {status: 'Published'},
                {status: 'Archived'},
            ],
            selectKey: 0,
            selectKey1: 0,
            node: new Node(),
            formSubmitted: false, // Add this flag to handle validation
            errorMessage: ''
        };
    },
    computed: {
        fieldValue() {
			return (fieldGroup, fieldTitle) => {
				return this.$store.getters["client/getNodeFieldValue"](fieldGroup, fieldTitle)
			}
		},
        ...mapState({
            getKeywordValue: state => state.client.currentNode.fieldGroups.keyword.fields.keyword.value
        }),
        ...mapGetters("client", ["getContentStrategy", "getClientUsers", "getClientData", "getCurrentNode", "getOpenKeywordPlannerModal", "getKeywordPlannerModal", "getModalKeywordData"]),
        ...mapGetters("auth", ["getAuthData", "getAuthRoleName"]),
        getAIPopUpFields() {
            return this.$store.getters['client/getAIPopUpFields'];
        },
    },
    state: {
        openKeywordPlannerModal: false,
    },
    mutations: {
        updateNodeFieldValue(state, { fieldGroup, field, value }) {
            console.log('fieldgroup1', fieldGroup);
            console.log('updated value test', value);

            if (
                state.node &&
                state.node.fieldGroups &&
                state.node.fieldGroups[fieldGroup] &&
                state.node.fieldGroups[fieldGroup].fields &&
                state.node.fieldGroups[fieldGroup].fields[field]
            ) {
                // Ensure Vue detects change
                state.node.fieldGroups[fieldGroup].fields[field].value = value;
            } else {
                console.error("Invalid field path:", fieldGroup, field);
            }
        },
        setOpenKeywordPlannerModal(state, value) {
            state.openKeywordPlannerModal = value;
        },
        resetNodeFields(state) {
            state.node.fieldGroups.title.fields.title.value = "";
            state.node.fieldGroups.details.fields.details.value = "";
            state.node.fieldGroups.keyword.fields.keyword.value = "";
        }
    },
    methods: {
        mapImportedNode(nodeData) {
            console.log('map imported node data', nodeData);
            if (!nodeData) return;

            this.node.id = nodeData.id;
            this.node.fieldGroups = {
                assign: nodeData.fieldGroup_Assign,
                author: nodeData.fieldGroup_Author,
                created: nodeData.fieldGroup_Created,
                deadline: nodeData.fieldGroup_Deadline,
                details: nodeData.fieldGroup_Details,
                format: nodeData.fieldGroup_Format,
                intent: nodeData.fieldGroup_Intent,
                keyword: nodeData.fieldGroup_Keyword,
                research: nodeData.fieldGroup_Research,
                status: nodeData.fieldGroup_Status,
                title: nodeData.fieldGroup_Title,
		    }
            console.log('the node data', this.node);

            console.log('Mapped node title:', this.node.fieldGroups?.title?.fields?.title?.value);
        },
        mapSelectFields(){
            console.log('mapSelectedFields', this.node.fieldGroups);
            
            if(this.node.fieldGroups.status.fields.status.value && this.node.fieldGroups.status.fields.status.value.status){
                this.node.fieldGroups.status.fields.status.value = this.node.fieldGroups.status.fields.status.value.status;
            }else if(this.node.fieldGroups.status.fields.status.value === undefined){
                this.node.fieldGroups.status.fields.status.value = '';
            }
            if(this.node.fieldGroups.format.fields.format.value && this.node.fieldGroups.format.fields.format.value.format){
                this.node.fieldGroups.format.fields.format.value = this.node.fieldGroups.format.fields.format.value.format;
            }else if(this.node.fieldGroups.format.fields.format.value === undefined){
                this.node.fieldGroups.format.fields.format.value = ''
            }
            if(this.node.fieldGroups.author.fields.author.value && this.node.fieldGroups.author.fields.author.value.username){
                this.node.fieldGroups.author.fields.author.value =  this.node.fieldGroups.author.fields.author.value.username
            }else if(this.node.fieldGroups.author.fields.author.value === undefined){
                this.node.fieldGroups.author.fields.author.value = ''
            }
            if(this.node.fieldGroups.assign.fields.assign.value && this.node.fieldGroups.assign.fields.assign.value.username){
                this.node.fieldGroups.assign.fields.assign.value = this.node.fieldGroups.assign.fields.assign.value.username;
            }else if(this.node.fieldGroups.assign.fields.assign.value === undefined){
                this.node.fieldGroups.assign.fields.assign.value = ''
            }
            console.log('mapSelectFields:', [
                this.node.fieldGroups.status.fields.status.value,
                this.node.fieldGroups.format.fields.format.value,
                this.node.fieldGroups.author.fields.author.value,
                this.node.fieldGroups.assign.fields.assign.value
            ])
        },
        onClose() {
            this.$store.commit('client/setContentStrategy', {prop: 'isEditing', val: false});
            this.$store.commit('client/setContentStrategy', {prop: 'currentNode', val: false});
        },
        onDelete() {
            this.$store.dispatch('client/onDeleteContentStrategyNode');
            this.$store.commit('client/setContentStrategy', {prop: 'currentNode', val: false});
            this.$store.dispatch('client/getAllContentStrategyNodes');
            this.$store.commit('client/setContentStrategy', {prop: 'isEditing', val: false});
        },
        onOpenKeywordPlannerModal() {
            console.log("Opening Keyword Planner Modal");
			this.$store.commit("client/setOpenKeywordPlannerModal", true);
		},
        updateKeyword(value) {
            console.log("Keyword set and closing modal");

            // Update keyword data
            this.$store.commit("client/setModalKeywordData", { title: value, reach: null });

            // Close the modal only if it's currently open
            if (this.$store.state.client.openKeywordPlannerModal) {
                this.$store.commit("client/setOpenKeywordPlannerModal", { prop: false, val: false });
            }

            //assign keyword value to node
            if (value !== '' && value !== null) {
                console.log('this is testing the keyword field value', value);
                this.node.fieldGroups.keyword.fields.keyword.value = value;
            }
        },
        updateFieldValue($event, fieldGroup, field, payload) {

            //let value = $event ? $event.target.value : payload
            let value = ($event && $event.target) ? $event.target.value : ($event ?? payload);

            if (field === 'assign' && value !== '' && value !== null){
                this.$store.commit("client/updateNodeFieldValue", {fieldGroup: 'status', field: 'status', value: 'Assigned'});
            }

            console.log('test value', value);

            //assign title value to node
            if (field === 'title') {
                console.log('this is testing the title field value', value);
                this.node.fieldGroups.title.fields.title.value = value;
            }
            if (field === 'details') {
                console.log('this is testing the details field value', value);
                this.node.fieldGroups.details.fields.details.value = value;
            }
            if (field === 'keyword') {
                console.log('this is testing the keyword field value', value);
                this.node.fieldGroups.keyword.fields.keyword.value = value;
            }

            if(field === 'status' && value === 'Approved' || field === 'status' && value === 'Rejected'){
                if(this.getClientData.mainContact){
                    if(this.getAuthData.username !== this.getClientData.mainContact.username){
                        alert('You must be the main contact to approve or reject');
                    }else{
                        console.log('1{fieldGroup, field, value}', [fieldGroup, field, value]);
                        this.$store.commit("client/updateNodeFieldValue", {fieldGroup, field, value})
                    }
                }else{
                    alert('main contact not set error');
                }
            }else{
                console.log('2{fieldGroup, field, value}', [fieldGroup, field, value]);
                this.$store.commit("client/updateNodeFieldValue", {fieldGroup, field, value})
            }
        },
        async handleSubmit() {
            // Set formSubmitted to true when the user attempts to submit the form
            this.formSubmitted = true;

            // Check if required fields are filled
            //const isTitleValid = !!this.node.fieldGroups.title.fields.title.value;
            const isTitleValid = !!this.fieldValue('title', 'title');
            const isFormatValid = !!this.node.fieldGroups.format.fields.format.value;

            if (!isTitleValid || !isFormatValid) {
                // Show an alert if any of the required fields are missing
                let missingFields = [];

                if (!isTitleValid) missingFields.push('Title');
                if (!isFormatValid) missingFields.push('Format');

                // Alert the user which fields are missing
                this.errorMessage = `Form submission prevented. Missing required fields: ${missingFields.join(', ')}`;
                return;
            }

            this.node.fieldGroups.status.fields.status.value = 'Title Created'

            // If validation passes, proceed with the submission
            try {
                this.mapSelectFields();
                console.log('node to update:', this.node);
                await this.$store.dispatch('client/createOrUpdateContentStrategyNode', {node: this.node});
                console.log('Node created/updated successfully');
                await this.$store.dispatch('client/getAllContentStrategyNodes');
                this.$store.commit('client/setContentStrategy', {prop: 'isEditing', val: false});
this.$store.commit('client/setContentStrategy', {prop: 'isAdding', val: false});
            this.$store.commit('client/setContentStrategy', {prop: 'currentNode', val: false});
            this.$store.commit("client/resetCurrentNode");
            } catch (error) {
                console.log('handleSubmit content strategy error', error);
            }
        }
    }
};
</script>

<style lang="scss">
@import "./../../../src/assets/scss/components/content-strategy.scss";

.has-error .modal-col-text input,
.has-error .modal-col-text .styled-select {
    border: 2px solid red;
}

.input-error {
    border: 2px solid red !important;
}
.btn-row-wrap{
    display: flex;
    width: 500px;
    align-items: center;
    justify-content: center;
    button:first-of-type{
        margin-right: 20px;
    }
    button{
        width: 130px !important;
        max-width: 130px !important;
    }
}
</style>
